import { PropsWithChildren } from "react"
import { EnvironmentType } from "../envTypes"
import { useMatchEnvironment } from "../envHooks"

type MatchEnvironmentProps = Readonly<PropsWithChildren<{
    environments: EnvironmentType[]
}>>

export function MatchEnvironment({ environments, children }: MatchEnvironmentProps) {
    const isMatch = useMatchEnvironment(environments)

    if (isMatch) {
        return (
            <>
                {children}
            </>
        )
    }

    return null
}
